<template>
    <div class="tw-flex">
        <Link :to="url" :target="target" class="lesson tw-inline-flex tw-items-center tw-text-gray-400 tw-font-semibold tw-p-4 hover:tw-bg-gray-100 tw-rounded-lg tw--ml-4">
            <i class="fa fa-check tw-text-green-500 tw-pr-3" v-if="lesson.seen"></i>
            <i class="fa fa-lock tw-text-gray-500 tw-pr-4 mimic-title" v-if="!lesson.availability.available || !module.available">
                <span v-if="!lesson.availability.available && lesson.availability.available_from !== null">{{ $t('membership.unlocks_at') }} {{ unlocksAt }}</span>
            </i>
            <i class="fad fa-graduation-cap" v-if="lesson.content_kind === 'quiz'"></i>
            <i class="fad fa-play" v-else-if="lesson.content_kind === 'video'"></i>
            <i class="fad fa-music" v-else-if="lesson.content_kind === 'audio'"></i>
            <i class="fad fa-book" v-else></i>
            <h3>{{ lesson.name }}</h3>
        </Link>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js'
    import Course from '../../mixins/v2/Course.js'
	import Link from "../Link";

    export default {
        name: 'Lesson',
		components: {
			Link
		},
		mixins: [Global, Course],

        props: {
            course: {
                required: true,
            },
			module: {
				required: true,
			},
			lesson: {
				required: true,
			},
        },

        computed: {
            url() {
	            if (!this.course.is_released && !this.$user.isModerator) {
		            return '#';
	            }


				if (!this.course.availability.available || !this.module.available) {
					if (!this.user && this.course.salespage === '' && (this.module.sales_page === '' || this.module.sales_page === null)) {
						return '/auth/login#login';
					} else if (this.module.available_from === null) {
						if (!this.module.available && this.module.sales_page !== '' && this.module.sales_page !== null) {
							return this.module.sales_page ?? '#';
						} else if (this.course.salespage !== '') {
							return this.course.salespage;
						} else {
		            		return '#';
						}
					}
				}

				return {
					name: 'lessons.show',
					params: {
						course_slug: this.course.slug,
						module_slug: this.module.slug,
						lesson_slug: this.lesson.slug,
					},
				};
            },

            target() {
                return this.url !== '#' ? '_blank' : '_self';
            },

            unlocksAt() {
                if (this.lesson.availability.available_from === null) {
                    return null;
                }

                return moment(this.lesson.availability.available_from).format("DD-MM-YYYY HH:mm");
            },
        },
    };
</script>

<style lang="scss" scoped>
    .lesson {
        i {
            @apply tw-pr-2;
        }

        .mimic-title {

            span {
                left: 52% !important;
                transform: translate(-48%);
                -webkit-transform: translate(-48%);
                -ms-transform: translate(-48%);
            }
        }
    }
</style>
